export const SocialData=[
    {
        platform:"Instagram",
        link:"https://www.instagram.com/romit.8/",
        icon:require('../../assets/icons/instagram.png').default
    },
    {
        platform:"Github",
        link:"https://github.com/romit0226",
        icon:require('../../assets/icons/github.png').default
    },
    {
        platform:"Linkedin",
        link:"https://www.linkedin.com/in/romit-choudhary-810794165/",
        icon:require('../../assets/icons/linkedin.png').default
    },
    {
        platform:"Twitter",
        link:"https://twitter.com/RomitChoudhary8",
        icon:require('../../assets/icons/twitter.png').default
    },
    {
        platform:"Facebook",
        link:"https://www.facebook.com/romit.buri",
        icon:require('../../assets/icons/facebook.png').default
    },
];